// extracted by mini-css-extract-plugin
export default {"wraper":"Login_wraper__qVozg","welcome-img":"Login_welcome-img__bsFEH","form-group":"Login_form-group__jNaBN","google-login-btn":"Login_google-login-btn__xSd7S"};